import { THEME_COLOR } from "../../../../styles/colors";
import Alert from "@amzn/meridian/esm/components/alert";
import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme";

const TREND_DISPLAY = {
  up: { symbol: "↑", color: "success" },
  down: { symbol: "↓", color: "error" },
  flat: { symbol: "→", color: "secondary" },
};

const MetricCard = ({ title, rows, alert }) => {
  return (
    <Theme tokens={{ boxBorderColorOutline: THEME_COLOR.MIST_GRAY, boxBorderRadiusOutline: 12 }}>
      <Box type="outline" spacingInset="400">
        <Column spacing="300">
          {title && <Text type="h100">{title}</Text>}
          {Array.isArray(rows) && rows.map((row, i) => {
              const trend = row.trend && TREND_DISPLAY[row.trend];
              return (
                <Row key={i} alignmentVertical="center" widths={["fill", "fit"]}>
                  <Text type="b200" color="secondary">{row.label}</Text>
                  <Row spacing="100" alignmentVertical="center">
                    <Text type="h50">{row.value}</Text>
                    {trend && (
                      <Text type="h50" color={trend.color}>{trend.symbol}</Text>
                    )}
                  </Row>
                </Row>
              );
            })}
            {alert && (
              <Alert size="small" type="warning">{alert}</Alert>
            )}
        </Column>
      </Box>
    </Theme>
  );
};

export default MetricCard;
